import { defineComponent as _, computed as u, openBlock as B, createElementBlock as k, normalizeClass as L, createElementVNode as x, toDisplayString as I } from "vue";
import { E as l } from "./chunks/EnumParser.dab943ef.js";
import { F as s } from "./chunks/FrontiersIcon.fac4da01.js";
import './assets/Card.css';import './assets/index6.css';/* empty css                                                      */var n = /* @__PURE__ */ ((e) => (e.Link = "linkButton", e.Flat = "flat", e.Outline = "outline", e.IconButton = "iconButton", e))(n || {}), c = /* @__PURE__ */ ((e) => (e.Grey = "grey", e.Grey80 = "grey80", e.White = "white", e.Sky40 = "sky40", e.Blue40 = "blue40", e.Blue50 = "blue50", e.Blue70 = "blue70", e.Blue80 = "blue80", e.Maincolor = "maincolor", e))(c || {}), r = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(r || {}), p = /* @__PURE__ */ ((e) => (e.Right = "right", e.Left = "left", e))(p || {});
const $ = ["type", "aria-label", "data-event"], M = /* @__PURE__ */ _({
  __name: "Button",
  props: {
    text: { default: "" },
    type: { default: "Flat" },
    icon: { default: "None" },
    size: { default: "Small" },
    color: { default: "Maincolor" },
    iconLocation: { default: "Right" },
    isLoading: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    nativeType: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: d }) {
    const t = e, f = u(() => l.getValue(n, t.type) === n.IconButton ? "" : t.text), m = u(() => l.getValue(n, t.type) === n.IconButton ? t.text : void 0), g = u(() => {
      const a = ["Button"], o = l.getValue(n, t.type), v = l.getValue(c, t.color), h = l.getValue(r, t.size), i = l.getValue(s, t.icon), V = l.getValue(
        p,
        t.iconLocation
      );
      return o !== n.Flat && a.push(`Button--${o}`), a.push(`Button--${v}`), a.push(`Button--${h}`), i !== s.None && (a.push(`Button--icon Button--${i}`), o !== n.IconButton && a.push(`Button--${V}`)), t.isLoading && a.push("Button--loading"), t.isDisabled && a.push("Button--disabled"), a;
    }), b = u(() => t.isLoading === !1 && t.isDisabled === !1);
    function y(a) {
      b.value && d("click", a);
    }
    return (a, o) => (B(), k("button", {
      type: a.nativeType,
      class: L(g.value),
      onClick: y,
      "aria-label": m.value,
      "data-event": a.$ga.getDataEventValue("btn", "action")
    }, [
      x("span", null, I(f.value), 1)
    ], 10, $));
  }
});
export {
  M as Button,
  c as ButtonColor,
  p as ButtonIconLocation,
  r as ButtonSize,
  n as ButtonType
};
